import { Reducer } from 'redux';
import t from './assetLibraryFilter.types';
import {
  AssetLibraryFilterState,
  Filter,
  FilterValue,
} from './assetLibraryFilter.types';

export type AssetLibraryFilterAction =
  | { type: typeof t.SET_LOADING; payload: boolean }
  | { type: typeof t.SET_ERROR; payload: string }
  | { type: typeof t.FETCH_FILTERS_SUCCESS; payload: Filter[] }
  | { type: typeof t.UPDATE_FILTER_LABEL; payload: { _id: string; label: string } }
  | { type: typeof t.TOGGLE_FILTER_ACTIVE; payload: { _id: string; isActive: boolean } }
  | { type: typeof t.ADD_VALUE; payload: { filterTypeId: string; value: FilterValue } }
  | { type: typeof t.EDIT_VALUE; payload: { filterTypeId: string; value: FilterValue } }
  | { type: typeof t.DELETE_VALUE; payload: { filterTypeId: string; valueId: string } }
  | { type: typeof t.SET_ACTIVE_PANEL; payload: string | null }
  | { type: typeof t.ADD_FILTER_TYPE; payload: Filter }
  | { type: typeof t.DELETE_FILTER_TYPE; payload: { _id: string } };

const initialState: AssetLibraryFilterState = {
  filters: [],
  loading: false,
  error: null,
  activePanel: null,
};

const AssetLibraryFilterReducer: Reducer<AssetLibraryFilterState, AssetLibraryFilterAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case t.SET_LOADING:
      return { ...state, loading: action.payload };

    case t.SET_ERROR:
      return { ...state, error: action.payload };

    case t.FETCH_FILTERS_SUCCESS:
      return { ...state, filters: action.payload, loading: false, error: null };

    case t.UPDATE_FILTER_LABEL:
      return {
        ...state,
        filters: state.filters.map((f) =>
          f._id === action.payload._id ? { ...f, label: action.payload.label } : f
        ),
      };

    case t.TOGGLE_FILTER_ACTIVE:
      return {
        ...state,
        filters: state.filters.map((f) =>
          f._id === action.payload._id ? { ...f, isActive: action.payload.isActive } : f
        ),
      };

    case t.ADD_VALUE:
      return {
        ...state,
        filters: state.filters.map((f) =>
          f._id === action.payload.filterTypeId
            ? { ...f, values: [...f.values, action.payload.value] }
            : f
        ),
      };

    case t.EDIT_VALUE:
      return {
        ...state,
        filters: state.filters.map((f) =>
          f._id === action.payload.filterTypeId
            ? {
                ...f,
                values: f.values.map((v) =>
                  v._id === action.payload.value._id ? action.payload.value : v
                ),
              }
            : f
        ),
      };

    case t.DELETE_VALUE:
      return {
        ...state,
        filters: state.filters.map((f) =>
          f._id === action.payload.filterTypeId
            ? { ...f, values: f.values.filter((v) => v._id !== action.payload.valueId) }
            : f
        ),
      };

    case t.SET_ACTIVE_PANEL:
      return { ...state, activePanel: action.payload };

    case t.ADD_FILTER_TYPE:
      return { ...state, filters: [...state.filters, action.payload] };

    case t.DELETE_FILTER_TYPE:
      return {
        ...state,
        filters: state.filters.filter((f) => f._id !== action.payload._id),
        activePanel: state.activePanel === action.payload._id ? null : state.activePanel,
      };

    default:
      return state;
  }
};

export default AssetLibraryFilterReducer;
